export default "__VITE_ASSET__FjoRG6r1__"